export interface IDonorConnectIldaUploadedFile {
    id: number,
    donorRegistrationId: number,
    uploadType: number,
    uploadDateTime: string,
    description: string,
    filePath: string
}